import {useBlockTypeLibrary} from './useBlockTypeLibrary';

export function getBlockIcon(block: any): string {
  const library = useBlockTypeLibrary();
  const blockType = library.find(block.type);
  return blockType?.icon || 'text';
}
